import Merge from './Merge'

export default Merge
